<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :disabled="disabled"
            :multiple="multiple"
            :autoComplete="autoComplete"
            :dense="dense"
            @clearSelected="$emit('clearSelected')"
        />
        <sys-register-curriculum @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectCurriculum',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        selectedObject: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        modelObject: {
        
        },
        disabled: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        courseId: {
           
        },
        disciplineId: {
            
        },
    },
    watch: {
        
        selected(val){
            
            if(val){
                this.$emit('update:model', val);
                
                var item = this.items.find(c => c.id == val);

                if(item) {
                    this.$emit('update:modelObject', item);
                }else{
                    this.$emit('update:modelObject', null);
                }
            }
        },

        selectedObject(val){
            this.$emit('update:modelObject', val);
        },
        
        model(val){
            this.selected = val;
        },

        courseId(){
            this.getItems();
        },

        disciplineId(){
            this.getItems();
        },

        modelObject(val){
            
            this.selectedObject = val;
            
            if(val && val.id){
                this.selected = val.id;
            }else{
                 this.selected = 0;
            }
           
        },
    },
    methods: {
        ...mapActions('curriculum', ['ActionFindCurriculums']),        
        
        async getItems() {

            this.loading = true;

            var payload = {
                with: 'sequencies.sequencyDisciplines.discipline,sequencies.sequencyDisciplines.category',
                find_columns: {
                    curriculum_status_id: 1
                }
            };

            if(this.courseId){
                payload.find_columns.course_id = this.courseId;
            }

            if(this.disciplineId){
                payload.filter_relations = [
                    {
                        name:   'sequencies.sequencyDisciplines',
                        key:    'discipline_id', 
                        value:  this.disciplineId,
                    }
                ];
            }

            await this.ActionFindCurriculums(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                        this.$emit('onLoad', this.items);
                       
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
        
            if(item){
                this.items.push(item);
                
                if(this.multiple){
                    
                    if(!this.selected){
                        this.selected = [];
                    }
                    
                    this.selected.push(item);
                }else{
                    this.selected = item.id;
                    this.selectedObject = item;
                }
                
                    this.showForm = false;

                }
        }
    },
    
}
</script>